import React from 'react';
import { Link } from 'react-router-dom';
import { useSearchParam } from 'react-use';
import text from '../../text';
import FormContainer from '../../components/containers/FormContainer';
var ResetPasswordSuccess = function() {
    var redirectUrlParam = useSearchParam('redirectUrl');
    return /*#__PURE__*/ React.createElement(FormContainer, null, /*#__PURE__*/ React.createElement(FormContainer.SecondaryHeader, null, /*#__PURE__*/ React.createElement("h2", null, text('success'), "!")), /*#__PURE__*/ React.createElement(FormContainer.Body, null, /*#__PURE__*/ React.createElement(FormContainer.PrimaryHeader, null, /*#__PURE__*/ React.createElement("h2", null, text('success'), "!")), /*#__PURE__*/ React.createElement("p", {
        className: "text-center"
    }, text('passwordReset')), /*#__PURE__*/ React.createElement(Link, {
        to: redirectUrlParam !== null && redirectUrlParam !== void 0 ? redirectUrlParam : '/',
        className: "btn btn-primary full-width"
    }, text('login'))));
};
export default ResetPasswordSuccess;
